import { LoginFormValues } from 'features/auth/login/types'
import { UserCredentials, User } from '@racepointenergy/swc/scs/types/user'

const USER_KEY = 'sav-user'
const CREDS_KEY = 'sav-creds'

export const getAuthorizedUser = (): (UserCredentials & User) | null => {
  const storedUser = localStorage.getItem(USER_KEY)
  if (storedUser) {
    try {
      return JSON.parse(storedUser) as UserCredentials & User
    } catch (err) {
      console.error('Error parsing stored authorized user', err)
    }
  }

  return null
}

export const storeAuthorizedUser = (user: UserCredentials & User) =>
  localStorage.setItem(USER_KEY, JSON.stringify(user))

export const storeUserCreds = (creds: LoginFormValues) =>
  localStorage.setItem(CREDS_KEY, JSON.stringify(creds))

export const clearAuthorizedUser = () => localStorage.removeItem(USER_KEY)
